import React from 'react';
import { Container, Row, Col, CardBody, Card } from 'reactstrap';
import DatePickerInput from '../../common/DatePickerInput'; // Adjust the import path as necessary

const DatePickerComponent = () => {
    return (
        <div className='page-content components'>
            <Container>
                <Card>
                    <CardBody>
                        <h2 className="mb-4">Date Picker Input Showcase</h2>
                        {/* First Row */}
                        <Row className="mb-4">
                            <Col lg={6}>
                                <DatePickerInput
                                    name="datePicker"
                                    id="datePickerInput"
                                    required={true}
                                    layout="below"
                                    showHelp={true}
                                    helpText="Please select a date."
                                />
                            </Col>
                            <Col lg={6}>
                                <div className="border p-3 rounded" style={{ backgroundColor: '#f8f9fa' }}>
                                    <pre>
                                        {`
<DatePickerInput
    name="datePicker"
    id="datePickerInput"
    required={true}
    layout="below"
    showHelp={true}
    helpText="Please select a date."
/>
                                        `}
                                    </pre>
                                </div>
                            </Col>
                        </Row>

                        {/* Second Row */}
                        <Row className="mb-4">
                            <Col lg={6}>
                                <DatePickerInput
                                    name="businessDate"
                                    id="businessDateInput"
                                    required={true}
                                    layout="below"
                                    showHelp={true}
                                    helpText="Please select a business date."
                                    dateRange={{
                                        minDate: new Date(), // Today's date
                                        maxDate: new Date(new Date().setFullYear(new Date().getFullYear() + 1)), // One year from today
                                    }}
                                />
                            </Col>
                            <Col lg={6}>
                                <div className="border p-3 rounded" style={{ backgroundColor: '#f8f9fa' }}>
                                    <pre>
                                        {`
<DatePickerInput
    name="businessDate"
    id="businessDateInput"
    required={true}
    layout="below"
    showHelp={true}
    helpText="Please select a business date."
    dateRange={{
        minDate: new Date(),
        maxDate: new Date(new Date().setFullYear(new Date().getFullYear() + 1)),
    }}
/>
                                        `}
                                    </pre>
                                </div>
                            </Col>
                        </Row>

                        {/* Third Row */}
                        <Row className="mb-4">
                            <Col lg={6}>
                                <DatePickerInput
                                    name="optionalDate"
                                    id="optionalDateInput"
                                    required={false}
                                    layout="below"
                                    placeholder="Select an optional date"
                                    showHelp={true}
                                    helpText="This date is optional."
                                />
                            </Col>
                            <Col lg={6}>
                                <div className="border p-3 rounded" style={{ backgroundColor: '#f8f9fa' }}>
                                    <pre>
                                        {`
<DatePickerInput
    name="optionalDate"
    id="optionalDateInput"
    required={false}
    layout="below"
    placeholder="Select an optional date"
    showHelp={true}
    helpText="This date is optional."
/>
                                        `}
                                    </pre>
                                </div>
                            </Col>
                        </Row>

                        {/* Fourth Row */}
                        <Row className="mb-4">
                            <Col lg={6}>
                                <DatePickerInput
                                    name="secondaryDate"
                                    id="secondaryDateInput"
                                    required={true}
                                    layout="below"
                                    showHelp={true}
                                    helpText="Please select a secondary date."
                                    dateRange={{
                                        minDate: new Date(new Date().setDate(new Date().getDate() + 1)), // Tomorrow
                                        maxDate: new Date(new Date().setFullYear(new Date().getFullYear() + 1)), // One year from today
                                    }}
                                />
                            </Col>
                            <Col lg={6}>
                                <div className="border p-3 rounded" style={{ backgroundColor: '#f8f9fa' }}>
                                    <pre>
                                        {`
<DatePickerInput
    name="secondaryDate"
    id="secondaryDateInput"
    required={true}
    layout="below"
    showHelp={true}
    helpText="Please select a secondary date."
    dateRange={{
        minDate: new Date(new Date().setDate(new Date().getDate() + 1)),
        maxDate: new Date(new Date().setFullYear(new Date().getFullYear() + 1)),
    }}
/>
                                        `}
                                    </pre>
                                </div>
                            </Col>
                        </Row>
                    </CardBody>
                </Card>
            </Container>
        </div>
    );
};

export default DatePickerComponent;
